export default {
  environment: import.meta.env.MODE,
  isLiveEnvironment: (): boolean => {
    return import.meta.env.MODE === 'staging' || import.meta.env.MODE === 'production';
  },
  isProductionEnvironment: (): boolean => {
    return import.meta.env.MODE === 'production';
  },
  apiUrl: import.meta.env.VITE_API_URL,
  mixpanel: {
    token: import.meta.env.VITE_MIXPANEL_TOKEN,
    devLoggerEnabled: true,
  },
  appUrl: import.meta.env.VITE_APP_URL,
};
